module.exports = new __parcel__URL__("light.45af45df.svg").toString();